export default __webpack_public_path__ + "static/media/radio-blank-red.3db5bf35.svg";